// Generated by generate-image-sizes.js. Run `node generate-image-sizes.js`
// after adding, removing, or re-encoding anything in public/images.
export default {
  browInnerUp: [1256, 890],
  browDownLeft: [1280, 892],
  browDownRight: [1280, 892],
  browOuterUpLeft: [1280, 892],
  browOuterUpRight: [1280, 892],
  eyeLookUpLeft: [1256, 891],
  eyeLookUpRight: [1256, 891],
  eyeLookDownLeft: [1256, 891],
  eyeLookDownRight: [1256, 891],
  eyeLookInLeft: [1256, 891],
  eyeLookInRight: [1256, 891],
  eyeLookOutLeft: [1256, 891],
  eyeLookOutRight: [1256, 891],
  eyeBlinkLeft: [1280, 892],
  eyeBlinkRight: [1280, 892],
  eyeSquintRight: [1256, 891],
  eyeSquintLeft: [1256, 891],
  eyeWideLeft: [1256, 891],
  eyeWideRight: [1256, 891],
  cheekPuff: [1304, 892],
  cheekSquintLeft: [1280, 892],
  cheekSquintRight: [1280, 892],
  noseSneerLeft: [1256, 887],
  noseSneerRight: [1256, 891],
  jawOpen: [1304, 936],
  jawForward: [1304, 892],
  jawLeft: [1304, 892],
  jawRight: [1304, 892],
  mouthFunnel: [1304, 894],
  mouthPucker: [1304, 892],
  mouthLeft: [1304, 892],
  mouthRight: [1304, 892],
  mouthRollUpper: [1304, 892],
  mouthRollLower: [1304, 892],
  mouthShrugUpper: [1304, 892],
  mouthShrugLower: [1304, 892],
  mouthClose: [1400, 674],
  mouthSmileLeft: [1280, 892],
  mouthSmileRight: [1282, 892],
  mouthFrownLeft: [1280, 895],
  mouthFrownRight: [1280, 895],
  mouthDimpleLeft: [1280, 894],
  mouthDimpleRight: [1280, 894],
  mouthUpperUpLeft: [1280, 892],
  mouthUpperUpRight: [1280, 892],
  mouthLowerDownLeft: [1266, 892],
  mouthLowerDownRight: [1265, 892],
  mouthPressLeft: [1280, 894],
  mouthPressRight: [1281, 894],
  mouthStretchLeft: [1280, 892],
  mouthStretchRight: [1280, 892],
};
